import { IconButton, IconButtonProps, Tooltip, TooltipProps } from '@mui/material';

type Props = IconButtonProps & {
  title?: string;
  tooltipProps?: Omit<TooltipProps, 'title' | 'children'>;
};

export default function IconButtonStyled({ onClick, title = '', children, disabled, tooltipProps, ...restProps }: Props) {
  if (!title || disabled) {
    return (
      <IconButton onClick={onClick} disabled={disabled} {...restProps}>
        {children}
      </IconButton>
    );
  }

  // span чтобы Tooltip не ругался когда кнопка disabled
  return (
    <Tooltip title={title} disableInteractive enterTouchDelay={700} {...tooltipProps}>
      <span>
        <IconButton onClick={onClick} {...restProps}>
          {children}
        </IconButton>
      </span>
    </Tooltip>
  );
}
